import { AuthModel } from "./_models";

const AUTH_COOKIE_NAME = "mcp-auth";

// Helper function to get cookie value by name
const getCookie = (name: string): string | null => {
  if (typeof document === "undefined") {
    return null;
  }

  const value = `; ${document.cookie}`;
  const parts = value.split(`; ${name}=`);
  if (parts.length === 2) {
    return parts.pop()?.split(";").shift() || null;
  }
  return null;
};

// Helper function to set cookie with security attributes
const setCookie = (name: string, value: string, days: number = 7) => {
  if (typeof document === "undefined") {
    return;
  }

  const expires = new Date();
  expires.setTime(expires.getTime() + days * 24 * 60 * 60 * 1000);

  // Set secure cookie with security attributes
  // Note: HttpOnly cannot be set from client-side JavaScript for security reasons
  // This should be handled by the server when setting cookies
  const isSecure = window.location.protocol === "https:";
  const cookieString = `${name}=${value}; expires=${expires.toUTCString()}; path=/; SameSite=Strict${
    isSecure ? "; Secure" : ""
  }`;

  document.cookie = cookieString;
};

// Helper function to remove cookie
const removeCookie = (name: string) => {
  if (typeof document === "undefined") {
    return;
  }

  const isSecure = window.location.protocol === "https:";
  document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/; SameSite=Strict${
    isSecure ? "; Secure" : ""
  }`;
};

const getAuth = (): AuthModel | undefined => {
  try {
    // Check localStorage instead of cookies
    const authData = localStorage.getItem(AUTH_COOKIE_NAME);
    if (authData) {
      const auth: AuthModel = JSON.parse(authData) as AuthModel;
      if (auth) {
        return auth;
      }
    }
  } catch (error) {
    console.error("AUTH LOCALSTORAGE PARSE ERROR", error);
  }
};

const setAuth = (auth: AuthModel) => {
  try {
    // Store in localStorage instead of cookies
    localStorage.setItem(AUTH_COOKIE_NAME, JSON.stringify(auth));
  } catch (error) {
    console.error("AUTH LOCALSTORAGE SAVE ERROR", error);
  }
};

const removeAuth = () => {
  try {
    // Remove from localStorage instead of cookies
    localStorage.removeItem(AUTH_COOKIE_NAME);
  } catch (error) {
    console.error("AUTH LOCALSTORAGE REMOVE ERROR", error);
  }
};

export function setupAxios(axios: any) {
  axios.defaults.headers.Accept = "application/json";
  // No need to add Authorization header since backend reads from httpOnly cookie
  // The withCredentials: true in requests ensures cookies are sent automatically
}

export { getAuth, setAuth, removeAuth, AUTH_COOKIE_NAME };
